import React, { FormEvent, useRef } from "react";
import { Popup } from "devextreme-react";
import { PopupRef, Position } from "devextreme-react/popup";
import { uqActions } from "@redux/uq/uq-slice";
import { CalculateGrid } from "@redux/uq/uq-actions";
import CustomButton from "@components/CustomButton";
import { closePopup } from "@helpers/DxHelper";
import NumberBoxWrapper from "@/components/NumberBoxWrapper";
import { UPSettings } from "@/types/types";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { NumberBoxRef } from "devextreme-react/cjs/number-box";

type Props = { popupRef: React.RefObject<PopupRef>; gridSet: any };

const ColaOverridePopup: React.FC<Props> = ({ popupRef, gridSet }) => {
  const { settings, updateHeader } = useAppSelector((state) => state.uq);
  const dispatch = useAppDispatch();
  const valueInputRef = useRef<NumberBoxRef>(null);

  const updateHeaderValues: Record<string, string> = {
    Income1: "colaIncome",
    Income2: "colaIncome2",
    SocialSecurity1: "colaSS1",
    SocialSecurity2: "colaSS2",
  };

  const updateHeaderKey = updateHeaderValues[updateHeader] as keyof typeof settings;
  const value = updateHeaderKey ? settings[updateHeaderKey] || settings?.cola : 0;

  const saveHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const newCola = Number(e.target[0]?.value);

    const settingsUpdate: Partial<UPSettings> = {};

    switch (updateHeader as keyof typeof updateHeaderValues) {
      case "Income1":
        settingsUpdate.colaIncome = newCola;
        break;
      case "Income2":
        settingsUpdate.colaIncome2 = newCola;
        break;
      case "SocialSecurity1":
        settingsUpdate.colaSS1 = newCola;
        break;
      case "SocialSecurity2":
        settingsUpdate.colaSS2 = newCola;
        break;
    }

    dispatch(uqActions.setIsModified(true));
    dispatch(uqActions.setSettings({ ...settings, ...settingsUpdate }));
    dispatch(CalculateGrid(0, gridSet));

    closePopup(popupRef);
  };

  const focusNumberInput = () => {
    if (valueInputRef?.current) {
      if (typeof value === "number") valueInputRef.current.instance().option("value", value);

      setTimeout(() => {
        valueInputRef?.current?.instance().focus();
      }, 100);
    }
  };

  return (
    <Popup
      width={210}
      height="fit"
      ref={popupRef}
      onShown={focusNumberInput}
      hideOnOutsideClick={true}
      showTitle={false}
    >
      <Position
        at="top"
        my="bottom"
        of={updateHeader ? `#${updateHeader}` : undefined}
        collision="fit flip"
      />
      <form onSubmit={saveHandler}>
        <div className="flex flex-col gap-6">
          <NumberBoxWrapper
            stylingMode="outlined"
            format="#0.##%"
            label="COLA Override"
            width={164}
            ref={valueInputRef}
            defaultValue={0.025}
          />
        </div>
        <CustomButton className="mt-7 h-11 w-full" text="Override" variant="primary" />
      </form>
    </Popup>
  );
};

export default ColaOverridePopup;
